module.exports = __webpack_public_path__ + "img/headerBg.76a2c562.jpg";